// ============================================================================
// note-client-mod -- useDeleteNote Hook
//
// 删除笔记 mutation。
// ============================================================================
import { useState, useCallback } from 'react';
import { getNoteApiClient } from '../note-api-client.js';
export function useDeleteNote() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState(null);
    const deleteNote = useCallback(async (id) => {
        setDeleting(true);
        setError(null);
        try {
            await getNoteApiClient().deleteNote(id);
            return true;
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '删除笔记失败');
            return false;
        }
        finally {
            setDeleting(false);
        }
    }, []);
    return { deleting, error, deleteNote };
}
//# sourceMappingURL=use-delete-note.js.map